import React, { useState } from "react";


const searchTypes = [
  {
    value: "date",
    label: "Дата",
  },
  {
    value: "client_name",
    label: "Контрагент",
  },
  {
    value: "payment_agent",
    label: "Платежный агент",
  },
  {
    value: "money_sum",
    label: "Сумма",
  },
  {
    value: "currency",
    label: "Валюта",
  },
  {
    value: "purpose",
    label: "Назначение",
  },
  {
    value: "comment",
    label: "Комментарий",
  },
  {
    value: "payment_status",
    label: "Статус",
  },
];


export default function SearchPanel({
  onSearch,
  clients,
}) {


  const [field, setField] = useState("counterparty");

  const [value, setValue] = useState("");



  const changeField = (e) => {

    setField(e.target.value);
    setValue("");

    onSearch(
      e.target.value,
      ""
    );

  };



  const changeValue = (e) => {

    const val = e.target.value;

    setValue(val);


    onSearch(
      field,
      val
    );

  };



  return (

    <div className="border rounded p-4 mb-5 bg-gray-50">

      <div className="flex gap-3 items-center">


        <select
          className="border p-2 rounded w-64"
          value={field}
          onChange={changeField}
        >

          {searchTypes.map((item)=>(

            <option
              key={item.value}
              value={item.value}
            >
              {item.label}
            </option>

          ))}

        </select>



          {field === "date" ? (

            <input
              type="date"
              className="border p-2 rounded flex-1"
              value={value}
              onChange={changeValue}
            />

          ) : field === "client_name" ? (

            <select
              className="border p-2 rounded flex-1"
              value={value}
              onChange={changeValue}
            >
              <option value="">
                Все контрагенты
              </option>

              {clients.map(client => (
                <option
                  key={client.id}
                  value={client.name}
                >
                  {client.name}
                </option>
              ))}

            </select>

          ) : field === "currency" ? (

            <select
              className="border p-2 rounded flex-1"
              value={value}
              onChange={changeValue}
            >
              <option value="">
                Все валюты
              </option>

              <option value="RUB">RUB</option>
              <option value="USD">USD</option>
              <option value="CNY">CNY</option>
              <option value="HKD">HKD</option>
              <option value="TRX">TRX</option>
              <option value="USDT">USDT</option>

            </select>

          ) : field === "payment_status" ? (

            <select
              className="border p-2 rounded flex-1"
              value={value}
              onChange={changeValue}
            >
              <option value="">
                Все статусы
              </option>

              <option value="PENDING">
                Ожидает оплаты
              </option>

              <option value="PAID">
                Оплачен
              </option>

            </select>

          ) : (

            <input
              className="border p-2 rounded flex-1"
              placeholder={`Введите ${
                searchTypes.find(x => x.value === field)?.label
              }`}
              value={value}
              onChange={changeValue}
            />

          )}



        {value && (

          <button

            className="px-3 py-2 bg-gray-200 rounded"

            onClick={()=>{

              setValue("");

              onSearch(
                field,
                ""
              );

            }}

          >

            Очистить

          </button>

        )}


      </div>


    </div>

  );

}